import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {madnes_get_pos_y, madnes_get_visible, madnes_set_visible} from "../framework/src/engine/madnes/madnes_object";
import {madnes_anim_scale} from "./turbo27_anims";

/**
 * @constructor
 * @param {string} name
 * @param {number} xScale
 * @param {number} yScale
 * @param {number} duration
 * @param {number=} delay
 * @returns {AnimScale}
 */
export function AnimScale(name, xScale, yScale, duration, delay) {
    this.name = name;
    this.xScale = xScale;
    this.yScale = yScale;
    this.duration = duration;
    this.delay = delay;
};

/**
 * @returns {Promise}
 */
AnimScale.prototype.run = function() {
    var _self = this;
    return new Promise(function(res) {
        madnes_anim_scale(_self.name, _self.xScale, _self.yScale, _self.duration, _self.delay, res);
    });
};


/**
 * @constructor
 * @param {string} type
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @returns {AnimFade}
 */
export function AnimFade(type, name, duration, delay) {
    this._name = name;
    this._duration = duration;
    this._delay = delay;
    this._type = type;

    /** {Phaser.Tween} */
    this._tween;
};

/**
 * @returns {Promise}
 */
AnimFade.prototype.run = function() {
    var _self = this;

    return new Promise(function(res) {
        _self._tween = madnes_tween_to(_self._name, { 'alpha': _self._type === "out" ? 0 : 1 }, {
            'duration': _self._duration,
            'delay': _self._delay,
            'callback': res
        });
    });
};

AnimFade.prototype.stop = function() {
    this._tween && this._tween.stop();
};


/**
 * @constructor
 * @param {Array<string>|string} names
 * @param {number} count
 * @param {number} duration
 * @returns {AnimBlink}
 */
export function AnimBlink(names, count, duration) {

    if(typeof names == 'object') {
        this.names = names;

    } else {
        this.names = [names];
    }

    this.count = count;
    this.duration = Math.floor(duration / count / 2);

    this.origVisibility = madnes_get_visible(this.names[0]);
    this.state = 0;

    /** @type {Function} */
    this.resolver;
    this.timeoutFunc = null;
    this.stopped = false;
};

AnimBlink.prototype.setVisible = function(objects, visible) {
    for (var i = 0, len = objects.length; i < len; i++) {
        madnes_set_visible(objects[i], visible);
    }
};

AnimBlink.prototype._step = function() {
    var _self = this;

    if(this.stopped) {
        return false;
    }

    if(this.count <= 0) {
        this.setVisible(this.names, this.origVisibility);
        this.resolver && this.resolver();
        return false;
    }

    var isVisible = madnes_get_visible(this.names[0]);

    this.timeoutFunc = setTimeout(function() {
        if(_self.origVisibility != isVisible) {
            _self.count--;
        }

        _self.setVisible(_self.names, !isVisible);
        _self._step();

    }, this.duration);
};

AnimBlink.prototype.run = function() {
    var _this = this;
    this.stopped = false;

    return new Promise(function(resolve) {
        _this.resolver = resolve;
        _this._step();
    });
};

AnimBlink.prototype.stop = function() {
    this.resolver = null;
    this.stopped = true;

    if(this.timeoutFunc) {
        clearTimeout(this.timeoutFunc);
    }
};

/**
 * @constructor {AnimOscilation}
 * @param {string} name
 * @param {number} y
 * @param {number} duration
 * @returns {AnimOscilation}
 */
export function AnimOscilation(name, y, duration) {

    this._name = name;
    this._dur = duration;
    this._y = y;

    /** {Phaser.Tween} */
    this._tween;
};

AnimOscilation.prototype.stop = function() {
    this._tween && this._tween.stop();
};

AnimOscilation.prototype.run = function() {

    var _self = this;

//	return new Promise(function() {

    var y = madnes_get_pos_y(_self._name);

    _self._tween = madnes_tween_to(_self._name, { 'y': y + _self._y }, {
        'duration': _self._dur,
        'yoyo': true,
        'count': -1
    });
//	});
};